import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { lightGreen } from "@mui/material/colors";
import { alpha, styled } from "@mui/material/styles";

const GreenSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: lightGreen[500],
    "&:hover": {
      backgroundColor: alpha(
        lightGreen[500],
        theme.palette.action.hoverOpacity
      ),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: lightGreen[500],
  },
}));

const SwitchPubilcNews = ({ params, handleSwitch }) => {
  return (
    <>
      <strong>
        <FormControlLabel
          sx={{ margin: "5px", alignItems: "left" }}
          control={
            <GreenSwitch
              checked={params.row.pubrel_enable === 0 ? false : true}
              //   checked={ipStatus[params.row.ipaddr]}
              onChange={(event) =>
                handleSwitch(
                  event,
                  params.row.pubrel_id,
                  params.row.pubrel_enable
                )
              }
            />
          }
          label={params.row.pubrel_enable === 0 ? "ไม่เผยแพร่" : "เผยแพร่"}
        />
      </strong>
    </>
  );
};

export default SwitchPubilcNews;
